export default {

    init() {
        console.log('init common...');
        document.addEventListener("DOMContentLoaded", this.bindEvents);

    },

    bindEvents() {
        Common.scrollbarWidth();
        
        var links = document.getElementsByTagName('a');
        for(var i = 0; i < links.length; i++) {
            var hrefHostname = new URL(links[i].href).hostname;

            var matches = (hrefHostname == window.location.hostname || 'www.' + hrefHostname == window.location.hostname || hrefHostname == 'www.' + window.location.hostname);
            if(!matches) links[i].target = '_blank';
        }
    },

    scrollbarWidth() {
        let scrollbarWidth = window.innerWidth - document.body.clientWidth;
        let root = document.querySelector(':root');

        root.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
    },

    isMobile() {
        return window.matchMedia('(max-width: 1023px)').matches;
    },

    getPrefersReducedMotion() {
		return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	},
};